import { ResourcePage } from "@/components/resource-page"
import { z } from "zod"
import { MessageSquare } from "lucide-react"

const messageSchema = z.object({
  key: z.string().min(1, "Key is required"),
  text: z.string().min(1, "Text is required"),
  category: z.string().optional(),
  parse_mode: z.enum(["HTML", "Markdown"]).optional(),
})

const messageColumns = [
  { key: "id", type: "text", options: { label: "ID" } },
  { key: "key", type: "text", options: { label: "Key" } },
  { key: "text", type: "text", options: { label: "Text" } },
  { key: "category", type: "text", options: { label: "Category" } },
  { key: "parse_mode", type: "text", options: { label: "Parse Mode" } },
  { key: "updated_at", type: "date", options: { label: "Updated" } },
]

const messageFormFields = [
  { name: "key", label: "Key", type: "text", placeholder: "Enter message key" },
  { name: "text", label: "Text", type: "textarea", placeholder: "Enter message text" },
  { name: "category", label: "Category", type: "text", placeholder: "Enter category" },
  {
    name: "parse_mode",
    label: "Parse Mode",
    type: "select",
    options: [
      { value: "HTML", label: "HTML" },
      { value: "Markdown", label: "Markdown" },
    ],
  },
]

export default function MessagesPage() {
  return (
    <ResourcePage
      resource="ui/messages"
      title="Messages"
      icon={MessageSquare}
      columns={messageColumns}
      formFields={messageFormFields}
      formSchema={messageSchema}
    />
  )
}
